import type { TeacherStudentListElement } from "@shared-kernel/application/ports/teacher/teacher-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveTeacherStudents = createApiThunk<TeacherStudentListElement[], void>(
  "teachers/retrieveTeacherStudents",
  async (_: void, { extra: { teacherRepository } }) => {
    return teacherRepository!.all();
  },
);
